<template>
  <v-container>

    <v-card>
      <v-toolbar flat color="blue accent-2" class="white--text">
        <v-btn to="/" icon text>
          <v-icon small class="white--text">mdi-home</v-icon>
        </v-btn>
        <v-toolbar-title>
          <h3 class="font-weight-light">Paquetes Directorio</h3>
        </v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <loader v-if="isloading"></loader>

        <v-row dense>
          <v-col class="mt-2" cols="12">
            <v-btn :to="`/editar-paquete-app`" depressed rounded class="white--text" color="green">
              crear nuevo package
            </v-btn>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12">
            <v-data-table :headers="headers" :items="items" disable-pagination hide-default-footer item-key="key" class="elevation-1 mt-6">

              <template v-slot:item.action="{ item }">

                <router-link :to="`/editar-paquete-app?id=${item.id}`">
                  <v-icon small class="mr-2" color="blue">
                    mdi-pencil
                  </v-icon>
                </router-link>

                <v-icon small color="red lighten-1">
                  mdi-trash-can
                </v-icon>
              </template>

            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>

    </v-card>


  </v-container>
</template>

<script>
  import {
    paquetes_service
  } from '~/paquetes_service'

  export default {

    data() {
      return {
        items: [],

        headers: [{
            text: 'Titulo',
            value: 'title',
          },
          {
            text: 'Tipo',
            value: 'packageType',
          },
          {
            text: 'Precio ($)',
            value: 'price',
          },
          {
            text: 'Acciones',
            value: 'action',
            sortable: false
          },
        ],
      }
    },

    created() {
      this.getPaquetes()
    },

    methods: {
      getPaquetes(role) {
        paquetes_service.get_packages('APP').then(res => {
          this.items = res.data
        }, res => {
          this.$toast.error('Error consultando registro')
        })
      },
    },
    computed: {
      isloading() {
        return this.$store.getters.getloading
      },
      errors() {
        return this.$store.getters.geterrors
      },
      user() {
        return JSON.parse(localStorage.getItem('user'))
      },
      categoria() {
        return this.$store.getters.get_categoria
      }
    }
  }
</script>